import React from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { FiMail } from 'react-icons/fi';
import RainbowText from '../components/RainbowText';
import './About.css';

const skills = [
  'C++',
  'JavaScript',
  'Python',
  'React',
  'Qt',
  'Node.js',
  'Git',
];

const About = () => {
  return (
    <div className="about-page">
      <main className="site-container--wide about-main">

        <header className="about-header">
          <h1 className="about-name">Kyra Thomas</h1>
          <p className="about-title">Software Engineer</p>
          <div className="about-accent-line" />
        </header>

        <section className="about-bio">
          <p>
            Software Engineer focused on building full-stack systems, software architecture, and system design. Interested in exploring creative applications of software and the intersection of technology and <RainbowText>interactive experiences</RainbowText>.
          </p>
        </section>

        <section className="about-skills">
          <h2 className="about-section-label">Technologies &amp; Tools</h2>
          <div className="about-skills-grid">
            {skills.map((skill) => (
              <span key={skill} className="about-skill-tag">{skill}</span>
            ))}
          </div>
        </section>

        <section className="about-contact">
          <h2 className="about-section-label">Connect</h2>
          <div className="about-contact-links">
            <a href="mailto:kyradthomas7@gmail.com" className="about-contact-link">
              <FiMail size={18} />
              <span>Email</span>
            </a>
            <a
              href="https://github.com/kdthomas7"
              target="_blank"
              rel="noreferrer"
              className="about-contact-link"
            >
              <FaGithub size={18} />
              <span>GitHub</span>
            </a>
            <a
              href="https://www.linkedin.com/in/kyra-thomas"
              target="_blank"
              rel="noreferrer"
              className="about-contact-link"
            >
              <FaLinkedin size={18} />
              <span>LinkedIn</span>
            </a>
          </div>
        </section>

      </main>
    </div>
  );
};

export default About;
